import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  imports: [],
  templateUrl: './access-denied.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './access-denied.component.scss',
})
export class AccessDeniedComponent {}
